<div *ngIf="!previewAvailable">
  <iframe [src]="previewUrl" width="1200" height="800px"></iframe>
</div>
<h3 *ngIf="previewAvailable" class="previewMsg">
  Preview is only available for PDF and CSV
</h3>
